import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import Banner from "../components/banner";

const BannerPage = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <Banner/>
      </main>
    </>
  );
};

export default BannerPage;
